module.exports = __webpack_public_path__ + "img/case-bj44.3e8c98e9.png";